import * as Yup from 'yup'

export const allValidationRules = Yup.object().shape({
  instructor_id: Yup.object().required('instructor is required').nullable(),
  date: Yup.string().required('Date is required'),
  from: Yup.string().required('From is required'),
  to: Yup.string().required('To is required'),
  level: Yup.number().required('Level is required').typeError('Level is required'),
  notes: Yup.string()
});